<div class="grid-wrapper">
  <div class="top-row">
    <div class="left-group">
      <div class="search">
        <i class="bi bi-search"></i>
        <input type="text" class="quick-filter-input" placeholder="Search from Definio Knowledge Base" [(ngModel)]="query" (keyup)="onKeyUp($event)">
      </div>
      <button class="search-button" (click)="search()">Search</button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <div *ngIf="isLoading" class="loading-message">
    Loading results... <div class="spinner"></div>
  </div>

  <div class="search-results" *ngIf="results">
    <h3>Search Results for "{{query}}"</h3>
    <button class="select-table-button" (click)="selectTable('ManufacturerItems')" *ngIf="results.ManufacturerItemsJson.ManufacturerItems.length">
      Manufacturer Items ({{ results.ManufacturerItemsJson.ManufacturerItems.length }})
    </button>
    <button class="select-table-button" (click)="selectTable('MaterialDesignations')" *ngIf="results.MaterialDesignationsJson.MaterialDesignations.length">
      Material Designations ({{ results.MaterialDesignationsJson.MaterialDesignations.length }})
    </button>
    <button class="select-table-button" (click)="selectTable('DimensionStandards')" *ngIf="results.DimensionStandardsJson.DimensionStandards.length">
      Dimension Standards ({{ results.DimensionStandardsJson.DimensionStandards.length }})
    </button>
    <button class="select-table-button" (click)="selectTable('MGMaterialGroupSpecificInstructions')" *ngIf="results.MGMaterialGroupSpecificInstructionsJson?.MGMaterialGroupSpecificInstructions?.length">
      MG Material Group Specific Instructions ({{ results.MGMaterialGroupSpecificInstructionsJson?.MGMaterialGroupSpecificInstructions?.length }})
    </button>
  </div>

  <div class="grid-wrapper">
    <ag-grid-angular
      *ngIf="selectedTable"
      class="ag-theme-alpine"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [pagination]="true"
      [paginationPageSize]="1000"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>